import PageTopbar from "../../components/PageTopbar";
import PageSeo from "../../components/PageSeo";
import Nd1SiteNav from "./Nd1SiteNav";
import Nd1SiteFooter from "./Nd1SiteFooter";
import { buildBreadcrumbNavItems } from "../../lib/pageSeo";
import "../nd1.css";

/** ND1 wrapper for Terms of Use, Privacy Policy, and Cookie Policy pages. */
export default function Nd1LegalShell({
  seo,
  backLabel = "Back to home",
  backTo = "/",
  breadcrumbLabel,
  breadcrumbPath,
  children,
}) {
  const currentLabel = breadcrumbLabel || backLabel;
  const currentPath = breadcrumbPath || backTo;

  return (
    <div className="nd1-root nd1-auth-page">
      <PageSeo {...seo} />
      <a href="#nd1-main" className="nd1-skip-link">
        Skip to content
      </a>
      <Nd1SiteNav />
      <main id="nd1-main">
        <section className="nd1-shell nd1-section nd1-legal">
          <PageTopbar
            backTo={backTo}
            backLabel={backLabel}
            breadcrumbItems={buildBreadcrumbNavItems([
              { name: "Home", path: "/" },
              { name: currentLabel, path: currentPath, current: true },
            ])}
          />
          {children}
        </section>
      </main>
      <Nd1SiteFooter />
    </div>
  );
}
